export default "__VITE_ASSET__DzuRT3RD__"